import React, { FC, forwardRef, useEffect, useState } from 'react';
import styles from "./styles.module.scss";
import { Flex, Space, Title, Slider, Image, ColorInput, Grid } from '@mantine/core';
import { HexColorPicker } from "react-colorful";
import { useMediaQuery } from '@mantine/hooks';
import { Divider, TextInput , Select } from '@common/components';
import { Eye, PenTool } from '@geist-ui/icons'
import EyeDropper from "src/assets/svg/eyedropper-svgrepo-com.svg"
import { ICustomOptionProps } from '@common/types/types';
import dropperIcon from 'src/assets/images/dropperIcon.png'
const auditStandards: any = {
    'WCAG 2.1A': {
        normalTextAA: 4.5,
        largeTextAA: 3,
        uiComponentsAA: 3,
    },
    'WCAG 2.1AA': {
        normalTextAA: 4.5,
        largeTextAA: 3,
        uiComponentsAA: 3,
    },
    // 'WCAG 2.1AAA': {
    //     normalTextAAA: 7,
    //     largeTextAAA: 4.5,
    // },
};



// Utility functions for color conversions
const hexToRgb = (hex: string) => {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
};

const rgbToCmyk = ({ r, g, b }: { r: number, g: number, b: number }) => {
    const c = 1 - (r / 255);
    const m = 1 - (g / 255);
    const y = 1 - (b / 255);
    const k = Math.min(c, Math.min(m, y));
    return {
        c: Math.round(((c - k) / (1 - k || 1)) * 100),
        m: Math.round(((m - k) / (1 - k || 1)) * 100),
        y: Math.round(((y - k) / (1 - k || 1)) * 100),
        k: Math.round(k * 100),
    };
};

const rgbToHsv = ({ r, g, b }: { r: number, g: number, b: number }) => {
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    const d = max - min;
    const s = (max === 0 ? 0 : d / max) * 100;
    const v = (max / 255) * 100;
    let h = 0;
    if (max !== min) {
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: Math.round(h * 360), s: Math.round(s), v: Math.round(v) };
};

const hexToHsl = (hex: string) => {
    let { r, g, b } = hexToRgb(hex);
    r /= 255;
    g /= 255;
    b /= 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h = 0, s = 0, l = (max + min) / 2;
    if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) };
};
// const colorNames = [
//     { name: "Black", hex: "#000000" },
//     { name: "White", hex: "#FFFFFF" },
//     { name: "Red", hex: "#FF0000" },
//     { name: "Lime", hex: "#00FF00" },
//     { name: "Blue", hex: "#0000FF" },
//     { name: "Yellow", hex: "#FFFF00" },
//     { name: "Cyan", hex: "#00FFFF" },
//     { name: "Magenta", hex: "#FF00FF" },
//     { name: "Silver", hex: "#C0C0C0" },
//     { name: "Gray", hex: "#808080" },
//     { name: "Maroon", hex: "#800000" },
//     { name: "Olive", hex: "#808000" },
//     { name: "Green", hex: "#008000" },
//     { name: "Purple", hex: "#800080" },
//     { name: "Teal", hex: "#008080" },
//     { name: "Navy", hex: "#000080" },
//     { name: "Orange", hex: "#FFA500" },
//     { name: "Pink", hex: "#FFC0CB" },
//     { name: "Brown", hex: "#A52A2A" },
//     { name: "Gold", hex: "#FFD700" },
//     { name: "Beige", hex: "#F5F5DC" },
//     { name: "Coral", hex: "#FF7F50" },
//     { name: "Turquoise", hex: "#40E0D0" },
//     { name: "Lavender", hex: "#E6E6FA" },
//     { name: "Salmon", hex: "#FA8072" },
//     { name: "Khaki", hex: "#F0E68C" },
//     { name: "Indigo", hex: "#4B0082" },
//     { name: "Violet", hex: "#EE82EE" },
//     { name: "Plum", hex: "#DDA0DD" },
//     { name: "Orchid", hex: "#DA70D6" },
//     { name: "Aquamarine", hex: "#7FFFD4" },
//     { name: "Tan", hex: "#D2B48C" },
//     { name: "Slate Gray", hex: "#708090" },
//     { name: "Light Gray", hex: "#D3D3D3" },
//     { name: "Dark Gray", hex: "#A9A9A9" },
//     { name: "Dark Red", hex: "#8B0000" },
//     { name: "Dark Green", hex: "#006400" },
//     { name: "Dark Blue", hex: "#00008B" },
//     { name: "Dark Cyan", hex: "#008B8B" },
//     { name: "Dark Magenta", hex: "#8B008B" },
//     { name: "Dark Olive Green", hex: "#556B2F" },
//     { name: "Crimson", hex: "#DC143C" },
//     { name: "Chartreuse", hex: "#7FFF00" },
//     { name: "Sea Green", hex: "#2E8B57" },
//     { name: "Forest Green", hex: "#228B22" },
//     { name: "Medium Sea Green", hex: "#3CB371" },
//     { name: "Spring Green", hex: "#00FF7F" },
//     { name: "Lawn Green", hex: "#7CFC00" },
//     { name: "Lime Green", hex: "#32CD32" },
//     { name: "Pale Green", hex: "#98FB98" },
//     { name: "Light Green", hex: "#90EE90" },
//     { name: "Dark Goldenrod", hex: "#B8860B" },
//     { name: "Goldenrod", hex: "#DAA520" },
//     { name: "Rosy Brown", hex: "#BC8F8F" },
//     { name: "Saddle Brown", hex: "#8B4513" },
//     { name: "Sienna", hex: "#A0522D" },
//     { name: "Firebrick", hex: "#B22222" },
//     { name: "Chocolate", hex: "#D2691E" },
//     { name: "Sandy Brown", hex: "#F4A460" },
//     { name: "Dark Orange", hex: "#FF8C00" },
//     { name: "Tomato", hex: "#FF6347" },
//     { name: "Orange Red", hex: "#FF4500" },
//     { name: "Dark Salmon", hex: "#E9967A" },
//     { name: "Light Salmon", hex: "#FFA07A" },
//     { name: "Peach Puff", hex: "#FFDAB9" },
//     { name: "Pale Goldenrod", hex: "#EEE8AA" },
//     { name: "Moccasin", hex: "#FFE4B5" },
//     { name: "Papaya Whip", hex: "#FFEFD5" },
//     { name: "Misty Rose", hex: "#FFE4E1" },
//     { name: "Lavender Blush", hex: "#FFF0F5" },
//     { name: "Linen", hex: "#FAF0E6" },
//     { name: "Antique White", hex: "#FAEBD7" },
//     { name: "Old Lace", hex: "#FDF5E6" },
//     { name: "Ivory", hex: "#FFFFF0" },
//     { name: "Honeydew", hex: "#F0FFF0" },
//     { name: "Mint Cream", hex: "#F5FFFA" },
//     { name: "Azure", hex: "#F0FFFF" },
//     { name: "Alice Blue", hex: "#F0F8FF" },
//     { name: "Ghost White", hex: "#F8F8FF" },
//     { name: "Snow", hex: "#FFFAFA" },
//     { name: "Cornsilk", hex: "#FFF8DC" },
//     { name: "Blanched Almond", hex: "#FFEBCD" },
//     { name: "Bisque", hex: "#FFE4C4" },
//     { name: "Wheat", hex: "#F5DEB3" },
//     { name: "Light Goldenrod Yellow", hex: "#FAFAD2" },
//     { name: "Lemon Chiffon", hex: "#FFFACD" },
//     { name: "Light Yellow", hex: "#FFFFE0" },
//     { name: "Seashell", hex: "#FFF5EE" },
//     { name: "Floral White", hex: "#FFFAF0" },
//     { name: "Light Steel Blue", hex: "#B0C4DE" },
//     { name: "Powder Blue", hex: "#B0E0E6" },
//     { name: "Pale Turquoise", hex: "#AFEEEE" },
//     { name: "Light Blue", hex: "#ADD8E6" },
//     { name: "Sky Blue", hex: "#87CEEB" },
//     { name: "Deep Sky Blue", hex: "#00BFFF" },
//     { name: "Dodger Blue", hex: "#1E90FF" },
//     { name: "Royal Blue", hex: "#4169E1" },
//     { name: "Steel Blue", hex: "#4682B4" },
//     { name: "Slate Blue", hex: "#6A5ACD" },
//     { name: "Medium Slate Blue", hex: "#7B68EE" },
//     { name: "Dark Slate Blue", hex: "#483D8B" },
//     { name: "Medium Purple", hex: "#9370DB" },
//     { name: "Rebecca Purple", hex: "#663399" },
//     { name: "Blue Violet", hex: "#8A2BE2" },
//     { name: "Medium Orchid", hex: "#BA55D3" },
//     { name: "Dark Orchid", hex: "#9932CC" },
//     { name: "Dark Violet", hex: "#9400D3" },
//     { name: "Medium Violet Red", hex: "#C71585" },
//     { name: "Pale Violet Red", hex: "#DB7093" },
// ];

const colorNames = [
    { label: 'aliceblue', value: '#F0F8FF' },
    { label: 'antiquewhite', value: '#FAEBD7' },
    { label: 'aqua', value: '#00FFFF' },
    { label: 'aquamarine', value: '#7FFFD4' },
    { label: 'azure', value: '#F0FFFF' },
    { label: 'beige', value: '#F5F5DC' },
    { label: 'bisque', value: '#FFE4C4' },
    { label: 'black', value: '#000000' },
    { label: 'blanchedalmond', value: '#FFEBCD' },
    { label: 'blue', value: '#0000FF' },
    { label: 'blueviolet', value: '#8A2BE2' },
    { label: 'brown', value: '#A52A2A' },
    { label: 'burlywood', value: '#DEB887' },
    { label: 'cadetblue', value: '#5F9EA0' },
    { label: 'chartreuse', value: '#7FFF00' },
    { label: 'chocolate', value: '#D2691E' },
    { label: 'coral', value: '#FF7F50' },
    { label: 'cornflowerblue', value: '#6495ED' },
    { label: 'cornsilk', value: '#FFF8DC' },
    { label: 'crimson', value: '#DC143C' },
    { label: 'cyan', value: '#00FFFF' },
    { label: 'darkblue', value: '#00008B' },
    { label: 'darkcyan', value: '#008B8B' },
    { label: 'darkgoldenrod', value: '#B8860B' },
    { label: 'darkgray', value: '#A9A9A9' },
    { label: 'darkgreen', value: '#006400' },
    { label: 'darkgrey', value: '#A9A9A9' },
    { label: 'darkkhaki', value: '#BDB76B' },
    { label: 'darkmagenta', value: '#8B008B' },
    { label: 'darkolivegreen', value: '#556B2F' },
    { label: 'darkorange', value: '#FF8C00' },
    { label: 'darkorchid', value: '#9932CC' },
    { label: 'darkred', value: '#8B0000' },
    { label: 'darksalmon', value: '#E9967A' },
    { label: 'darkseagreen', value: '#8FBC8F' },
    { label: 'darkslateblue', value: '#483D8B' },
    { label: 'darkslategray', value: '#2F4F4F' },
    { label: 'darkslategrey', value: '#2F4F4F' },
    { label: 'darkturquoise', value: '#00CED1' },
    { label: 'darkviolet', value: '#9400D3' },
    { label: 'deeppink', value: '#FF1493' },
    { label: 'deepskyblue', value: '#00BFFF' },
    { label: 'dimgray', value: '#696969' },
    { label: 'dimgrey', value: '#696969' },
    { label: 'dodgerblue', value: '#1E90FF' },
    { label: 'firebrick', value: '#B22222' },
    { label: 'floralwhite', value: '#FFFAF0' },
    { label: 'forestgreen', value: '#228B22' },
    { label: 'fuchsia', value: '#FF00FF' },
    { label: 'gainsboro', value: '#DCDCDC' },
    { label: 'ghostwhite', value: '#F8F8FF' },
    { label: 'gold', value: '#FFD700' },
    { label: 'goldenrod', value: '#DAA520' },
    { label: 'gray', value: '#808080' },
    { label: 'green', value: '#008000' },
    { label: 'greenyellow', value: '#ADFF2F' },
    { label: 'grey', value: '#808080' },
    { label: 'honeydew', value: '#F0FFF0' },
    { label: 'hotpink', value: '#FF69B4' },
    { label: 'indianred', value: '#CD5C5C' },
    { label: 'indigo', value: '#4B0082' },
    { label: 'ivory', value: '#FFFFF0' },
    { label: 'khaki', value: '#F0E68C' },
    { label: 'lavender', value: '#E6E6FA' },
    { label: 'lavenderblush', value: '#FFF0F5' },
    { label: 'lawngreen', value: '#7CFC00' },
    { label: 'lemonchiffon', value: '#FFFACD' },
    { label: 'lightblue', value: '#ADD8E6' },
    { label: 'lightcoral', value: '#F08080' },
    { label: 'lightcyan', value: '#E0FFFF' },
    { label: 'lightgoldenrodyellow', value: '#FAFAD2' },
    { label: 'lightgray', value: '#D3D3D3' },
    { label: 'lightgreen', value: '#90EE90' },
    { label: 'lightgrey', value: '#D3D3D3' },
    { label: 'lightpink', value: '#FFB6C1' },
    { label: 'lightsalmon', value: '#FFA07A' },
    { label: 'lightseagreen', value: '#20B2AA' },
    { label: 'lightskyblue', value: '#87CEFA' },
    { label: 'lightslategray', value: '#778899' },
    { label: 'lightslategrey', value: '#778899' },
    { label: 'lightsteelblue', value: '#B0C4DE' },
    { label: 'lightyellow', value: '#FFFFE0' },
    { label: 'lime', value: '#00FF00' },
    { label: 'limegreen', value: '#32CD32' },
    { label: 'linen', value: '#FAF0E6' },
    { label: 'magenta', value: '#FF00FF' },
    { label: 'maroon', value: '#800000' },
    { label: 'mediumaquamarine', value: '#66CDAA' },
    { label: 'mediumblue', value: '#0000CD' },
    { label: 'mediumorchid', value: '#BA55D3' },
    { label: 'mediumpurple', value: '#9370DB' },
    { label: 'mediumseagreen', value: '#3CB371' },
    { label: 'mediumslateblue', value: '#7B68EE' },
    { label: 'mediumspringgreen', value: '#00FA9A' },
    { label: 'mediumturquoise', value: '#48D1CC' },
    { label: 'mediumvioletred', value: '#C71585' },
    { label: 'midnightblue', value: '#191970' },
    { label: 'mintcream', value: '#F5FFFA' },
    { label: 'mistyrose', value: '#FFE4E1' },
    { label: 'moccasin', value: '#FFE4B5' },
    { label: 'navajowhite', value: '#FFDEAD' },
    { label: 'navy', value: '#000080' },
    { label: 'oldlace', value: '#FDF5E6' },
    { label: 'olive', value: '#808000' },
    { label: 'olivedrab', value: '#6B8E23' },
    { label: 'orange', value: '#FFA500' },
    { label: 'orangered', value: '#FF4500' },
    { label: 'orchid', value: '#DA70D6' },
    { label: 'palegoldenrod', value: '#EEE8AA' },
    { label: 'palegreen', value: '#98FB98' },
    { label: 'paleturquoise', value: '#AFEEEE' },
    { label: 'palevioletred', value: '#DB7093' },
    { label: 'papayawhip', value: '#FFEFD5' },
    { label: 'peachpuff', value: '#FFDAB9' },
      { label: "peru", value: "#CD853F" },
      { label: "pink", value: "#FFC0CB" },
      { label: "plum", value: "#DDA0DD" },
      { label: "powderblue", value: "#B0E0E6" },
      { label: "purple", value: "#800080" },
      { label: "red", value: "#FF0000" },
      { label: "rosybrown", value: "#BC8F8F" },
      { label: "royalblue", value: "#4169E1" },
      { label: "saddlebrown", value: "#8B4513" },
      { label: "salmon", value: "#FA8072" },
      { label: "sandybrown", value: "#F4A460" },
      { label: "seagreen", value: "#2E8B57" },
      { label: "seashell", value: "#FFF5EE" },
      { label: "sienna", value: "#A0522D" },
      { label: "silver", value: "#C0C0C0" },
      { label: "skyblue", value: "#87CEEB" },
      { label: "slateblue", value: "#6A5ACD" },
      { label: "slategray", value: "#708090" },
      { label: "slategrey", value: "#708090" },
      { label: "snow", value: "#FFFAFA" },
      { label: "springgreen", value: "#00FF7F" },
      { label: "steelblue", value: "#4682B4" },
      { label: "tan", value: "#D2B48C" },
      { label: "teal", value: "#008080" },
      { label: "thistle", value: "#D8BFD8" },
      { label: "tomato", value: "#FF6347" },
      { label: "turquoise", value: "#40E0D0" },
      { label: "violet", value: "#EE82EE" },
      { label: "wheat", value: "#F5DEB3" },
      { label: "white", value: "#FFFFFF" },
      { label: "whitesmoke", value: "#F5F5F5" },
      { label: "yellow", value: "#FFFF00" },
      { label: "yellowgreen", value: "#9ACD32" },
      { label: "N/A", value: "N/A" },
]
  
  

//   const getColorName = (hex: string) => {
//     const hexToRgb = (hex: string) => {
//         const bigint = parseInt(hex.slice(1), 16);
//         return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
//     };

//     const [r1, g1, b1] = hexToRgb(hex);
//     let closestColor = { name: "Unknown", distance: Infinity };

//     colorNames.forEach(({ name, hex: colorHex }) => {
//         const [r2, g2, b2] = hexToRgb(colorHex);
//         const distance = Math.sqrt(
//             Math.pow(r2 - r1, 2) + Math.pow(g2 - g1, 2) + Math.pow(b2 - b1, 2)
//         );

//         if (distance < closestColor.distance) {
//             closestColor = { name, distance };
//         }
//     });

//     return closestColor.name;
// };
  
const getColorName = (hex: string) => {
    const closestColor = colorNames.reduce(
        (closest, current) => {
            const distance = Math.sqrt(
                Math.pow(parseInt(hex.slice(1, 3), 16) - parseInt(current.value.slice(1, 3), 16), 2) +
                Math.pow(parseInt(hex.slice(3, 5), 16) - parseInt(current.value.slice(3, 5), 16), 2) +
                Math.pow(parseInt(hex.slice(5, 7), 16) - parseInt(current.value.slice(5, 7), 16), 2)
            );
            return distance < closest.distance ? { name: current.label, distance } : closest;
        },
        { name: 'Unknown', distance: Infinity }
    );
    return closestColor.name;
};
// const colorNames = [
//     { name: "Black", hex: "#000000" },
//     { name: "White", hex: "#FFFFFF" },
//     { name: "Red", hex: "#FF0000" },
//     { name: "Lime", hex: "#00FF00" },
//     { name: "Blue", hex: "#0000FF" },
//     { name: "Yellow", hex: "#FFFF00" },
//     { name: "Cyan", hex: "#00FFFF" },
//     { name: "Magenta", hex: "#FF00FF" },
//     { name: "Silver", hex: "#C0C0C0" },
//     { name: "Gray", hex: "#808080" },
//     { name: "Maroon", hex: "#800000" },
//     { name: "Olive", hex: "#808000" },
//     { name: "Green", hex: "#008000" },
//     { name: "Purple", hex: "#800080" },
//     { name: "Teal", hex: "#008080" },
//     { name: "Navy", hex: "#000080" },
//     { name: "Orange", hex: "#FFA500" },
//     { name: "Pink", hex: "#FFC0CB" },
//     { name: "Brown", hex: "#A52A2A" },
//     { name: "Gold", hex: "#FFD700" },
//     { name: "Beige", hex: "#F5F5DC" },
//     { name: "Coral", hex: "#FF7F50" },
//     { name: "Turquoise", hex: "#40E0D0" },
//     { name: "Lavender", hex: "#E6E6FA" },
//     { name: "Salmon", hex: "#FA8072" },
//     { name: "Khaki", hex: "#F0E68C" },
//     { name: "Indigo", hex: "#4B0082" },
//     { name: "Violet", hex: "#EE82EE" },
//     { name: "Plum", hex: "#DDA0DD" },
//     { name: "Orchid", hex: "#DA70D6" },
//     { name: "Aquamarine", hex: "#7FFFD4" },
//     { name: "Tan", hex: "#D2B48C" },
//     { name: "Slate Gray", hex: "#708090" },
//     { name: "Light Gray", hex: "#D3D3D3" },
//     { name: "Dark Gray", hex: "#A9A9A9" },
//     { name: "Dark Red", hex: "#8B0000" },
//     { name: "Dark Green", hex: "#006400" },
//     { name: "Dark Blue", hex: "#00008B" },
//     { name: "Dark Cyan", hex: "#008B8B" },
//     { name: "Dark Magenta", hex: "#8B008B" },
//     { name: "Dark Olive Green", hex: "#556B2F" },
//     { name: "Crimson", hex: "#DC143C" },
//     { name: "Chartreuse", hex: "#7FFF00" },
//     { name: "Sea Green", hex: "#2E8B57" },
//     { name: "Forest Green", hex: "#228B22" },
//     { name: "Medium Sea Green", hex: "#3CB371" },
//     { name: "Spring Green", hex: "#00FF7F" },
//     { name: "Lawn Green", hex: "#7CFC00" },
//     { name: "Lime Green", hex: "#32CD32" },
//     { name: "Pale Green", hex: "#98FB98" },
//     { name: "Light Green", hex: "#90EE90" },
//     { name: "Dark Goldenrod", hex: "#B8860B" },
//     { name: "Goldenrod", hex: "#DAA520" },
//     { name: "Rosy Brown", hex: "#BC8F8F" },
//     { name: "Saddle Brown", hex: "#8B4513" },
//     { name: "Sienna", hex: "#A0522D" },
//     { name: "Firebrick", hex: "#B22222" },
//     { name: "Chocolate", hex: "#D2691E" },
//     { name: "Sandy Brown", hex: "#F4A460" },
//     { name: "Dark Orange", hex: "#FF8C00" },
//     { name: "Tomato", hex: "#FF6347" },
//     { name: "Orange Red", hex: "#FF4500" },
//     { name: "Dark Salmon", hex: "#E9967A" },
//     { name: "Light Salmon", hex: "#FFA07A" },
//     { name: "Peach Puff", hex: "#FFDAB9" },
//     { name: "Pale Goldenrod", hex: "#EEE8AA" },
//     { name: "Moccasin", hex: "#FFE4B5" },
//     { name: "Papaya Whip", hex: "#FFEFD5" },
//     { name: "Misty Rose", hex: "#FFE4E1" },
//     { name: "Lavender Blush", hex: "#FFF0F5" },
//     { name: "Linen", hex: "#FAF0E6" },
//     { name: "Antique White", hex: "#FAEBD7" },
//     { name: "Old Lace", hex: "#FDF5E6" },
//     { name: "Ivory", hex: "#FFFFF0" },
//     { name: "Honeydew", hex: "#F0FFF0" },
//     { name: "Mint Cream", hex: "#F5FFFA" },
//     { name: "Azure", hex: "#F0FFFF" },
//     { name: "Alice Blue", hex: "#F0F8FF" },
//     { name: "Ghost White", hex: "#F8F8FF" },
//     { name: "Snow", hex: "#FFFAFA" },
//     { name: "Cornsilk", hex: "#FFF8DC" },
//     { name: "Blanched Almond", hex: "#FFEBCD" },
//     { name: "Bisque", hex: "#FFE4C4" },
//     { name: "Wheat", hex: "#F5DEB3" },
//     { name: "Light Goldenrod Yellow", hex: "#FAFAD2" },
//     { name: "Lemon Chiffon", hex: "#FFFACD" },
//     { name: "Light Yellow", hex: "#FFFFE0" },
//     { name: "Seashell", hex: "#FFF5EE" },
//     { name: "Floral White", hex: "#FFFAF0" },
//     { name: "Light Steel Blue", hex: "#B0C4DE" },
//     { name: "Powder Blue", hex: "#B0E0E6" },
//     { name: "Pale Turquoise", hex: "#AFEEEE" },
//     { name: "Light Blue", hex: "#ADD8E6" },
//     { name: "Sky Blue", hex: "#87CEEB" },
//     { name: "Deep Sky Blue", hex: "#00BFFF" },
//     { name: "Dodger Blue", hex: "#1E90FF" },
//     { name: "Royal Blue", hex: "#4169E1" },
//     { name: "Steel Blue", hex: "#4682B4" },
//     { name: "Slate Blue", hex: "#6A5ACD" },
//     { name: "Medium Slate Blue", hex: "#7B68EE" },
//     { name: "Dark Slate Blue", hex: "#483D8B" },
//     { name: "Medium Purple", hex: "#9370DB" },
//     { name: "Rebecca Purple", hex: "#663399" },
//     { name: "Blue Violet", hex: "#8A2BE2" },
//     { name: "Medium Orchid", hex: "#BA55D3" },
//     { name: "Dark Orchid", hex: "#9932CC" },
//     { name: "Dark Violet", hex: "#9400D3" },
//     { name: "Medium Violet Red", hex: "#C71585" },
//     { name: "Pale Violet Red", hex: "#DB7093" },
//   ];
  

const rgbaToHex = (rgba: string): string => {
    // Extract numbers from RGBA string
    const match = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/i);
    if (!match) {
        console.warn('Invalid RGBA format:', rgba);
        return '#000000'; // Fallback to black if the format is invalid
    }

    const r = parseInt(match[1]);
    const g = parseInt(match[2]);
    const b = parseInt(match[3]);

    // Convert to hexadecimal
    const toHex = (value: number) => value.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
  


const CustomOption: FC<ICustomOptionProps> = ({ label,value, ...props }) => {
     
    return (
      <Flex justify={"space-between"} align={"center"} {...props} role="option" aria-label={label}>
         {label}
         <span className={styles.colorPreview} style={{ backgroundColor:value  }}></span>
      </Flex>
    );
  };
  

const ToolsPage: React.FC = () => {
    const [foreground, setForeground] = useState('#4169E1');
    const [background, setBackground] = useState('#708090');
    const [selectedStandard, setSelectedStandard] = useState<any>('WCAG 2.1A');
    const standard = auditStandards[selectedStandard];
    const isMobile = useMediaQuery('(max-width: 991px)');

    const rgb = hexToRgb(foreground);
    const cmyk = rgbToCmyk(rgb);
    const hsv = rgbToHsv(rgb);
    const hsl = hexToHsl(foreground);

    useEffect(() => {

        updateForegroundColor(foreground);
     
    }, [foreground])
    
    useEffect(() => {

        updateBackgroundColor(background);
     
    }, [background])

    const [foregroundName, setForegroundName] = useState('');
    const [backgroundName, setBackgroundName] = useState('');

    const updateForegroundColor = (newColor: string) => {
        setForeground(newColor);
        setForegroundName(getColorName(newColor));
    };

    const updateBackgroundColor = (newColor: string) => {
        setBackground(newColor);
        setBackgroundName(getColorName(newColor));
    };

    const calculateLuminance = (color: string): number => {
        const rgb = color.match(/\w\w/g)?.map((c) => parseInt(c, 16) / 255);
        if (!rgb || rgb.length !== 3) {
            console.warn(`Invalid color format: ${color}`);
            return 0;
        }
        const [r, g, b] = rgb.map(channel =>
            channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4)
        );
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };

    const getContrastRatio = (fg: string, bg: string): number => {
        const fgLum = calculateLuminance(fg);
        const bgLum = calculateLuminance(bg);
        return (Math.max(fgLum, bgLum) + 0.05) / (Math.min(fgLum, bgLum) + 0.05);
    };

    const contrastRatio = getContrastRatio(foreground, background);
    const passesNormalAA = contrastRatio >= (standard.normalTextAA || 0);
    const passesNormalAAA = contrastRatio >= (standard.normalTextAAA || 0);
    const passesLargeAA = contrastRatio >= (standard.largeTextAA || 0);
    const passesLargeAAA = contrastRatio >= (standard.largeTextAAA || 0);
    const passesUIAA = contrastRatio >= (standard.uiComponentsAA || 0);

    const [selectedColor, setSelectedColor] = useState('#000000');
    const [colorName, setColorName] = useState('Unknown');
    const handleEyeDropper = async (place: string) => {
        if ('EyeDropper' in window) {
            try {
                const eyeDropper = new (window as any).EyeDropper();
                const result = await eyeDropper.open();
                // setSelectedColor(result.sRGBHex);
                // setColorName(getColorName(result.sRGBHex));
                if (place == 'Background') {
                    setBackground(rgbaToHex(result.sRGBHex));
                }
                else{
                    setForeground(rgbaToHex(result.sRGBHex));
                }
            } catch (error) {
                console.error('Error using eyedropper:', error);
            }
        } else {
            alert('Eyedropper API is not supported in your browser.');
        }
    };
    
    // Add state to track lightness adjustment for foreground and background
    const [foregroundLightness, setForegroundLightness] = useState(0); // 0 means no change
    const [backgroundLightness, setBackgroundLightness] = useState(0); 

    const adjustLightness = (hex: string, percentage: number): string => {
        // Convert hex color to RGB
        const hexToRgb = (hex: string) => {
            const bigint = parseInt(hex.slice(1), 16);
            return {
                r: (bigint >> 16) & 255,
                g: (bigint >> 8) & 255,
                b: bigint & 255,
            };
        };
    
        // Convert RGB back to Hex format
        const rgbToHex = ({ r, g, b }: { r: number; g: number; b: number }): string => {
            const toHex = (value: number) => value.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        };
    
        // Function to adjust the value of a single color channel based on lightness percentage
        const adjust = (value: number) => {
            // Lighten or darken the color
            const adjustedValue = value + (percentage / 100) * (255 - value);
            return Math.round(Math.min(255, Math.max(0, adjustedValue)));
        };
    
        const { r, g, b } = hexToRgb(hex);
    
        // Adjust each RGB channel based on the percentage value
        const adjustedRgb = {
            r: adjust(r),
            g: adjust(g),
            b: adjust(b),
        };
    
        // Return the adjusted color as a hex value
        return rgbToHex(adjustedRgb);
    };
    
    
    
    

    useEffect(() => {

        console.log( `foregroundLightness` , foregroundLightness );
        console.log( `foreground` , foreground );
        
        const value = adjustLightness(foreground, foregroundLightness)
        console.log( value );
        
        setForeground(value);
    }, [foregroundLightness]);
    
    useEffect(() => {
        setBackground(adjustLightness(background, backgroundLightness));
    }, [backgroundLightness]);
    
    const colors = [
        { name: 'aliceblue', hex: '#F0F8FF', hsl: '240, 100%, 97%' },
        { name: 'antiquewhite', hex: '#FAEBD7', hsl: '30, 77%, 91%' },
        { name: 'aqua', hex: '#00FFFF', hsl: '180, 100%, 50%' },
        { name: 'aquamarine', hex: '#7FFFD4', hsl: '160, 100%, 75%' },
        { name: 'azure', hex: '#F0FFFF', hsl: '180, 100%, 97%' },
        { name: 'beige', hex: '#F5F5DC', hsl: '60, 56%, 91%' },
        { name: 'bisque', hex: '#FFE4C4', hsl: '33, 100%, 88%' },
      ];

    const [ colorNameLabel , setColorNameLabel ] = useState("#4169E1")
    const [ colorNamebg , setColorNamebg ] = useState("#708090")
    return (
        <div  className={styles['wrraper_mobile']} style={{ backgroundColor: '#F5F7FA' }}>


 
            <div className={styles.container_bg}>
                <Flex justify={'space-between'} direction={isMobile ? 'column' : 'row'}>
                    <Flex align={"center"} gap={"sm"}>
                        <Title order={1} id={'mainContent'} color="#264547" className={styles.heading}>
                            Contrast Checker
                        </Title>
                    </Flex>
                </Flex>
                <Divider />
                <Space h={"md"} />
            </div>
            <div className={styles.wrraper} >
                <div className={styles.container}>
                    <div className={styles.contrastRatio}>
                        <h3 >Contrast Ratio: {contrastRatio.toFixed(2)}:1</h3>
                    </div>
                    <div className={styles.colorPickerContainer}>
                        <div className={styles.colorPicker}>
                            <h2 className={styles.subheading}>Foreground</h2>
                            <HexColorPicker style={{width:"auto"}} color={foreground} onChange={(e)=> {
                                const colorValue = colorNames.find(color => color.value.toLocaleLowerCase() == e.toLocaleLowerCase())
                                setForeground(e)
                                colorValue ?  setColorNameLabel(colorValue?.value) : setColorNameLabel('N/A')
                            }} />
                            <Space h={"md"} />
                            <Slider
                                label="Lightness"
                                value={foregroundLightness}
                                onChange={setForegroundLightness}
                                min={-100}
                                max={100}
                                step={1}
                            />
                            <Space h={"md"} />
                            <ColorInput
                                size="md"
                                radius="md"
                                aria-label="Enter a color code (Hex or RGB) to change the background color"
                                placeholder="Input placeholder"
                                value={foreground}
                                onChange={(e) => setForeground(e)}
                                // withPreview={false}
                                withPicker={false}
                                eyeDropperIcon ={<img src={dropperIcon} style={{ width : '45px' }} alt='Eyedropper Image' />}
                            />
                            {/* <TextInput
                                placeholder='Enter Color : #2E2E2E'
                                value={foreground}
                                onChange={(e) => setForeground(e.target.value)}
                                icon={<Image src={EyeDropper} style={{ width : "24px"}} aria-label='Select Color Picker' onClick={()=> handleEyeDropper('Foreground')} />}
                            /> */}
                            <Space h={"md"} />
                            <Flex className={styles.containerSelect} align={"center"} gap={"sm"}>
                                <label>Color Name :</label>  
                                <Select
                                    className={styles.wFull}
                                    variant="secondary"
                                    aria-label={`Colors`}
                                    value={colorNameLabel}
                                    data={colorNames }
                                    searchable={true}
                                    onChange={(e) => e && setForeground(e) }
                                    itemComponent={CustomOption}
                                />
                                <span className={styles.colorPreview} style={{ backgroundColor : foreground }}></span>
                            </Flex>
                            {/* { JSON.stringify( foreground ) } */}
                            <div className={styles.colorFormats}>
                                <div>
                                    <strong>RGB:</strong> {rgb.r}, {rgb.g}, {rgb.b}
                                </div>
                                <div>
                                    <strong>CMYK:</strong> {cmyk.c}%, {cmyk.m}%, {cmyk.y}%, {cmyk.k}%
                                </div>
                                <div>
                                    <strong>HSV:</strong> {hsv.h}°, {hsv.s}%, {hsv.v}%
                                </div>
                                <div>
                                    <strong>HSL:</strong> {hsl.h}°, {hsl.s}%, {hsl.l}%
                                </div>
                            </div>
                        </div>

                        <div className={styles.colorPicker}>
                            <h2 className={styles.subheading}>Background</h2>
                            <HexColorPicker style={{ width: "auto" }} color={background} onChange={(e) => {
                                const colorValue = colorNames.find(color => color.value.toLocaleLowerCase() == e.toLocaleLowerCase())
                                setBackground(e)
                                colorValue ? setColorNamebg(colorValue?.value) : setColorNamebg('N/A')
                            }


                            } />
                            <Space h={"md"} />
                            <Slider
                                label="Lightness"
                                value={backgroundLightness}
                                onChange={setBackgroundLightness}
                                min={-100}
                                max={100}
                                step={1}
                            />
                            <Space h={"md"} />
                            {/* <TextInput
                                placeholder='Enter Color : #8F8F8F'
                                value={background}
                                onChange={(e) => setBackground(e.target.value)}
                                icon={<Image src={EyeDropper} style={{ width : "24px"}} aria-label='Select Color Picker' onClick={()=> handleEyeDropper('Background')} />}
                            /> */}
                            <ColorInput
                                size="md"
                                radius="md"
                                aria-label="Enter a color code (Hex or RGB) to change the background color"
                                placeholder="Input placeholder"
                                value={background}
                                onChange={(e) => setBackground(e)}
                                withPicker={false}
                                eyeDropperIcon ={<img src={dropperIcon} style={{ width : '45px' }} alt='Eyedropper Image' />}
                            />
                            <Space h={"md"} />
                            <Flex className={styles.containerSelect} align={"center"} gap={"sm"}>
                                <label>Color Name :</label>  
                                <Select
                                    className={styles.wFull}
                                    variant="secondary"
                                    aria-label={`Colors`}
                                    value={colorNamebg}
                                    data={colorNames}
                                    searchable={true}
                                    onChange={(e) => e && setForeground(e) }
                                    itemComponent={CustomOption}
                                />
                                <span className={styles.colorPreview} style={{ backgroundColor : background }}></span>
                            </Flex>
                            <div className={styles.colorFormats}>
                                <div>
                                    <strong>RGB:</strong> {hexToRgb(background).r}, {hexToRgb(background).g}, {hexToRgb(background).b}
                                </div>
                                <div>
                                    <strong>CMYK:</strong> {rgbToCmyk(hexToRgb(background)).c}%, {rgbToCmyk(hexToRgb(background)).m}%, {rgbToCmyk(hexToRgb(background)).y}%, {rgbToCmyk(hexToRgb(background)).k}%
                                </div>
                                <div>
                                    <strong>HSV:</strong> {rgbToHsv(hexToRgb(background)).h}°, {rgbToHsv(hexToRgb(background)).s}%, {rgbToHsv(hexToRgb(background)).v}%
                                </div>
                                <div>
                                    <strong>HSL:</strong> {hexToHsl(background).h}°, {hexToHsl(background).s}%, {hexToHsl(background).l}%
                                </div>
                            </div>
                        </div>
                    </div>                        
                    {/* Audit Standard Dropdown */}
                    <Flex align={"center"} justify={"space-between"} gap={"sm"} >
                        {/* <Select
                            withBorder={true}
                            variant='primary'
                            label="Select Audit Standard"
                            placeholder="Choose standard"
                            value={selectedStandard}
                            onChange={setSelectedStandard}
                            data={Object.keys(auditStandards)}
                            className={styles.auditDropdown}
                        /> */}
                    </Flex>
                    <p className={styles.textExample} style={{ color: foreground, backgroundColor: background, fontSize: '1.5rem', fontWeight: 'bold' }}>The five boxing wizards jump quickly.</p>
                    <div className={styles.resultContainer}>
                        <h4 className={styles.resultHeading}>Normal Text </h4>
                        <div>
                            <WCAGTable 
                                passesUIAA={passesUIAA}
                                passesLargeAA={passesLargeAA}
                                passesLargeAAA={passesLargeAAA}
                                passesNormalAAA={passesNormalAAA}
                            />
                            
                        </div>
                    </div>
                    <div className={styles.resultContainer}>
                        <h4 className={styles.resultHeading}>Large Text </h4>
                        <div>
                            <WCAGTable 
                                passesUIAA={passesUIAA}
                                passesLargeAA={passesLargeAA}
                                passesLargeAAA={passesLargeAAA}
                                passesNormalAAA={passesNormalAAA}
                            />
                            
                        </div>
                    </div>
                </div>
                
                {/* Display only the selected audit standard */}
                <div className={styles.tips}>
                    <h2 className={styles.tipsTitle}>{selectedStandard} Guidelines</h2>
                    <div className={styles.tipSection}>
                        <h3 className={styles.tipHeading}>Text Contrast Requirements</h3>
                        <ul>
                            <li>Normal Text AA: Minimum contrast ratio of {standard.normalTextAA}:1</li>
                            <li>Normal Text AAA: Minimum contrast ratio of {standard.normalTextAAA}:1</li>
                            <li>Large Text AA: Minimum contrast ratio of {standard.largeTextAA}:1</li>
                            <li>Large Text AAA: Minimum contrast ratio of {standard.largeTextAAA}:1</li>
                        </ul>
                    </div>
                    <div className={styles.tipSection}>
                        <h3 className={styles.tipHeading}>UI Components Contrast Requirements</h3>
                        <ul>
                            <li>UI Components AA: Minimum contrast ratio of {standard.uiComponentsAA}:1</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ToolsPage;
const WCAGTable = ({
    passesUIAA,
    passesLargeAA,
    passesLargeAAA,
    passesNormalAAA
  }: {
    passesUIAA: boolean;
    passesLargeAA: boolean;
    passesLargeAAA: boolean;
    passesNormalAAA: boolean;
  }) => {
    return (
      <div className={styles.criteriaContainer}>
        <table className={styles.criteriaTable}>
          <thead>
            <tr>
              <th>Criteria</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr className={styles.darkRow}>
              <td><strong>WCAG 2.0</strong></td>
              <td style={{ color: passesUIAA ? 'green' : 'red' }}>
                {passesUIAA ? 'Pass' : 'Fail'}
              </td>
            </tr>
            <tr className={styles.lightRow}>
              <td><strong>WCAG AA</strong></td>
              <td style={{ color: passesUIAA ? 'green' : 'red' }}>
                {passesUIAA ? 'Pass' : 'Fail'}
              </td>
            </tr>
            <tr className={styles.darkRow}>
              <td><strong>WCAG 2.1A</strong></td>
              <td style={{ color: passesLargeAA ? 'green' : 'red' }}>
                {passesLargeAA ? 'Pass' : 'Fail'}
              </td>
            </tr>
            <tr className={styles.lightRow}>
              <td><strong>WCAG 2.1AA</strong></td>
              <td style={{ color: passesLargeAAA ? 'green' : 'red' }}>
                {passesLargeAAA ? 'Pass' : 'Fail'}
              </td>
            </tr>
            <tr className={styles.darkRow}>
              <td><strong>WCAG 2.1AAA</strong></td>
              <td style={{ color: passesNormalAAA ? 'green' : 'red' }}>
                {passesNormalAAA ? 'Pass' : 'Fail'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };